import { useEffect } from "react";
import festival from "../images/Modals/Saltmine-mobile.jpg";
import festivalMobile from "../images/Modals/Saltmine.jpg";
import "../css/style.css";

const SpecialEventModal = ({ show, onClose }) => {
    useEffect(() => {
        document.body.style.overflow = show ? "hidden" : "";
        return () => (document.body.style.overflow = "");
    }, [show]);

    if (!show) return null;

    return (
        <>
            {/* Backdrop + click-off handler */}
            <div className="custom-modal-backdrop" onClick={onClose} />

            {/* Modal wrapper */}
            <div className="custom-modal" onClick={onClose}>
                {/* STOP clicks inside modal */}
                <div className="custom-modal-content" onClick={(e) => e.stopPropagation()} >
                    <div className="custom-modal-body">
                        <div className="ticket-image-wrapper">
                        <picture>{/*The <picture> tag is an HTML element that lets you provide multiple versions of an image and let the browser choose the most appropriate one.*/}
                            <source srcSet={festivalMobile} media="(max-width: 768px)"/>
                            <img src={festival} alt="Dirty Yachtin' Scoundrels Festival" />
                        </picture>
                            <a href="https://buytickets.at/pugetsoundworksllc/2419822" className="ticket-button" target="_blank" rel="noopener noreferrer">BUY TICKETS HERE</a>
                         </div>
                    </div>


                    <div className="custom-modal-footer">
                        <button onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SpecialEventModal;
